import { handleError, handleSuccess } from '../ulits';

const BASE_URL = 'https://mi-creator-online.onrender.com';

const getErrorMessage = (result) => {
  if (result && result.error && result.error.details && result.error.details[0]) {
    return result.error.details[0].message;
  }
  if (result && typeof result.error === 'string') {
    return result.error;
  }
  if (result && result.message) {
    return result.message;
  }
  return 'Something went wrong. Please try again.';
};

// Login
export const UserLogin = async ({ loginInfo }) => {
  try {
    const url = `${BASE_URL}/auth/login`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(loginInfo)
    });

    const result = await response.json();
    const { success, message, jwtToken, name, email, role } = result;

    if (success) {
      handleSuccess(message);
      localStorage.setItem('token', jwtToken);
      localStorage.setItem('loggedInUserName', name);
      localStorage.setItem('loggedINUserEmail', email);
      localStorage.setItem('role', role);
      return true;
    } else {
      handleError(getErrorMessage(result));
      return false;
    }
  } catch (err) {
    console.error('UserLogin fetch error:', err);
    handleError(err && err.message ? err.message : 'Network error. Please try again.');
    return false;
  }
};

// Signup
export const UserSign = async ({ signupInfo }) => {
  try {
    const url = `${BASE_URL}/auth/signup`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(signupInfo)
    });

    const result = await response.json();
    const { success } = result;

    if (success) {
      return true;
    } else {
      handleError(getErrorMessage(result));
      return false;
    }
  } catch (err) {
    console.error('UserSign fetch error:', err);
    handleError(err && err.message ? err.message : 'Network error. Please try again.');
    return false;
  }
};

// Reset Password
export const UserPasswordReset = async ({ id, token, password, confirmPassword }) => {
  try {
    const url = `${BASE_URL}/reset-password/${id}/${token}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ password, confirmPassword })
    });

    const result = await response.json();
    const { success } = result;

    if (success) {
      handleSuccess('Password reset Successfully');
      return true;
    } else {
      handleError(getErrorMessage(result));
      return false;
    }
  } catch (err) {
    console.error('UserPasswordReset fetch error:', err);
    handleError(err && err.message ? err.message : 'Network error. Please try again.');
    return false;
  }
};

// Forgot Password
export const UserForgotPassword = async ({ email }) => {
  try {
    const url = `${BASE_URL}/forgot-password`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    });

    const result = await response.json();
    const { success, message } = result;

    if (success) {
      handleSuccess(message);
      return true;
    } else {
      handleError(message);
      return false;
    }
  } catch (err) {
    console.error('UserForgotPassword fetch error:', err);
    handleError(err && err.message ? err.message : 'Network error. Please try again.');
    return false;
  }
};
